import { STATUS_CODE } from '~/constants'
import { ENDPOINT } from './endPoint'
import request from './request'

export const getBadgeNotificationApi = async ({ table_uuid, restaurant_slug }) => {
  const URL = ENDPOINT.GET_BADGE_NOTIFY

  const params = {}

  if (table_uuid) params.table_uuid = table_uuid
  if (restaurant_slug) params.restaurant_slug = restaurant_slug

  try {
    const { data, status } = await request().get(URL, { params })
    if (status === STATUS_CODE.NUM_SUCCESS) {
      return {
        isSuccess: true,
        hasNotify: data.requests_status_has_changed,
      }
    }
  } catch (error) {
    return {
      isSuccess: false,
      hasNotify: false,
      error_message: error.response?.data?.message,
    }
  }
}
